module.exports = __webpack_public_path__ + "img/2.2.763272f5.svg";